import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteCtx = createContext({ content: null, combos: [], loading: true });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [c, cm] = await Promise.all([
          axios.get(`${API}/site/content`),
          axios.get(`${API}/site/combos`),
        ]);
        if (!alive) return;
        setContent(c.data);
        setCombos(cm.data);
      } catch (e) {
        console.error("site content fetch failed", e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return <SiteCtx.Provider value={{ content, combos, loading }}>{children}</SiteCtx.Provider>;
}

export function useSiteContent() {
  return useContext(SiteCtx);
}
